import { Phase } from "../api/trade-to-earn/trade-to-earn-campaign.dto";
import { TradingCampaignRules } from "../api/trade-to-earn/trade-to-earn-rules";
import { CMSTradingCampaign } from "../cms/trade-to-earn";
import { Any } from "../fakeTypes";
import { SocialName } from "../shared/campaign-types";

/**
 * @deprecated These types are deprecated and will be removed in the future (as soon as all the packages are migrated to the new types)
 */

export const RuleLabels = {
  PROPORTIONAL: "Proportional",
  FCFS: "FCFS",
  PRIZE_BY_POSITION: "Prize by Position",
  CUSTOM: "Custom",
} as const;

export enum ProportionalCooldownMode {
  SLIDING_WINDOW = "slidding-window",
  FIXED_WINDOW = "fixed-window",
  NO_COOLDOWN = "no-cooldown",
}

export type CampaignMetadataEpoch = {
  id: number; // index of the epoch in the campaign
  start: Date;
  end: Date;
  rule: {
    rule: TradingCampaignRules;
    data: Any;
  };
  /**
   * @remarks
   * Means the epoch is paused (partially or fully)
   * - Partially paused: the epoch started but was paused before it ended
   * - Fully paused: the epoch was paused before it started
   */
  isPaused?: boolean;
  isPausedFrom?: Date;
  /**
   * @remarks
   * if the epoch is paused and the pause started before the current epoch start, then the epoch is considered fully paused
   * Otherwise, the epoch is considered partially paused (the pause started after the epoch start)
   */
  isFullyPaused?: boolean;
  exchangeIds?: string[];
  limitOrder?: boolean;
  maxDefiAddressesByExchangeUserId?: number;
  defiAddressBlockingPeriod?: "day" | "epoch";
  phases?: Phase[]; // Only used for PVP rule
  /**
   * @remarks
   * If set, only trade events from hub user having never traded before the given date will be considered for the leaderboard computation
   */
  onlyHubUserWithNoTradeEventsBefore?: Date;
  prizePoolToken?: string;
  rewardTokenAddress: string;
};

export type CampaignMetadata = Omit<CMSTradingCampaign, "attributes"> & {
  epochs: CampaignMetadataEpoch[];
  attributes: CMSTradingCampaign["attributes"];
  isEnded: boolean;
  isComing: boolean;
  isOngoing: boolean;
  isPaused: boolean;
  rewardVaultAddress: string | null;
  nextEpoch: CampaignMetadataEpoch | null;
  requiredSocialAccounts: SocialName[];
};

export * from "./reward";
export * from "./access";
export * from "./guards";
